const taxesUrl = '/taxes';
const settingsTaxesUrl = '/settings/taxes';
export default {
    /**
     *
     * @returns {Promise<Array>}
     * Return list of taxes
     */
    async getAllTaxes() {
        const params = {
            order: 'rank',
            include_ecotax: true,
            limit: 100,
            embed: ['acl', 'translations'],
        };
        const taxesResult = [];
        let result = await ApiClient.get(taxesUrl, params);
        taxesResult.push(...result.data.data);
        while (taxesResult.length < result.data.pagination.total) {
            params.offset = taxesResult.length;
            result = await ApiClient.get(taxesUrl, params);
            taxesResult.push(...result.data.data);
        }
        return taxesResult;
    },

    /**
     *
     * @returns {Promise<Array>}
     * Return list of taxes settings for VatSettings.vue
     */
    getTaxesSettings() {
        return ApiClient.get(settingsTaxesUrl);
    },

    /**
     *
     * @param {Array} taxes
     * @returns {Promise}
     * Update all taxes and fetch again to keep them sync with server
     */
    updateTaxes(taxes) {
        const taxesCopy = taxes.map((tax) => {
            return {
                id: tax.id,
                label: tax.label,
                rate: Number(tax.rate),
                is_active: tax.is_active,
                translations: [...tax.translations.filter((item) => item.value.trim())],
            };
        });

        return new Promise((resolve, reject) =>
            ApiClient.post(`${taxesUrl}/batch`, {}, taxesCopy)
                .then((response) => {
                    if (response.status !== 204) {
                        reject(response.status);
                    }
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                }),
        );
    },

    updateEcoTaxes(ecoTaxes) {
        const taxesCopy = JSON.parse(JSON.stringify(ecoTaxes)).map((tax) => {
            return {
                id: tax.id,
                label: tax.label,
                translations: [...tax.translations.filter((item) => item.value.trim())],
            };
        });

        return new Promise((resolve, reject) =>
            ApiClient.post('/ecotaxes/batch', {}, taxesCopy)
                .then((response) => {
                    if (response.status !== 204) {
                        reject(response.status);
                    }
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                }),
        );
    },

    /**
     *
     * @param {Array} settingsTaxes
     * Update all settings for taxes
     */
    updateTaxesSettings(settingsTaxes, signal = undefined) {
        return new Promise((resolve, reject) => {
            ApiClient.put(settingsTaxesUrl, {}, { ...settingsTaxes }, signal)
                .then((response) => {
                    if (response.status !== 200) {
                        reject(response.status);
                    }
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
